import VideoEditor from './VideoEditor';

export default VideoEditor;